let colours = {
    white: 'white',
    blue: '#0094d5',
    red: '#DD4124',
    black: 'black',
    green: '#43B7B2',
    orange: '#ff9425',
    purple: '#33257E',
    grey: '#A9A9AD'
}

export default {
    base: colours,
    arr: Object.keys(colours).map(c => {
        return {
            label: c.substr(0,1).toUpperCase() + c.substring(1),
            value: colours[c]
        }
    }),
    charts: Object.keys(colours).filter(c => c !== 'black' && c !== 'white').map(c => colours[c])
}

